import React, { ChangeEvent } from 'react';
import { Input } from 'reactstrap';

interface CuitInputProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  invalid?: boolean;
  required?: boolean;
  id?: string;
  name?: string;
}

const CuitInput: React.FC<CuitInputProps> = ({
  value,
  onChange,
  disabled,
  invalid,
  required,
  id,
  name,
}) => {
  const formatCuit = (value: string) => {
    const numbers = value.replace(/\D/g, '').slice(0, 11);

    const part1 = numbers.slice(0, 2);
    const part2 = numbers.slice(2, 10);
    const part3 = numbers.slice(10, 11);

    if (numbers.length <= 2) return part1;
    if (numbers.length <= 10) return `${part1}-${part2}`;
    return `${part1}-${part2}-${part3}`;
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.target.value = formatCuit(event.target.value);

    onChange(event);
  };

  return (
    <Input
      id={id}
      name={name}
      value={value ?? ''}
      onChange={handleChange}
      disabled={disabled}
      invalid={invalid}
      required={required}
      inputMode="numeric"
      pattern="[0-9]*"
      maxLength={13} // 11 números + 2 guiones
    />
  );
};

export default CuitInput;
